var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.module.persistent.show)?_c('RulerOverlayLayer',{attrs:{"module":_vm.module,"mode":_vm.mode,"tic":_vm.frameStore.tic},on:{"update:tic":function($event){return _vm.$set(_vm.frameStore, "tic", $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }